





















































































































































































import Loading from 'vue-loading-overlay';
import { Component, Prop, Vue, Emit, Mixins, Watch } from 'vue-property-decorator';
import Axios from 'axios';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import { Recipient } from '../models/Recipient';
import { SettingsService } from '../api/SettingsService';
import { MultipleSelect, MsgBox } from '../../core/components';
import Input from '../../core/components/Input.vue'
import InputPhone from '../../core/components/InputPhone.vue'

@Component({
    components: {
        Loading,
        MultipleSelect,
        Input,
        InputPhone
    }
})
export default class RecipientDialog extends Mixins(CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper) {
    @Prop() show: boolean;
    @Prop() editing: boolean;
    @Prop() recipientToEdit: Recipient;
    @Prop({
        default() {
            return [];
        }
    })
    companiesFromReports;
    preselectedCompanies: Array<object> = [];
    selectedCompanies: Array<object> = [];
    pendingRequest: boolean = false;
    cancelToken: any = null;

    @Watch('show')
    observableshow(value) {
        if (value) {
            this.cleanInputs();
        }

        if (!this.editing && this.companiesFromReports.length !== 0) {
            this.preselectedCompanies = this.companiesFromReports;
            this.selectedCompanies = this.companiesFromReports;
        }
    }

    updateName(value){
        this.nameInput = value;
    }
    updateMail(value){
        this.mailInput = value;
    }
    updatePhone(value){
        this.numberInput = value;
    }

    //inputs

    numberInput: string = '';
    nameInput: string = '';
    mailInput: string = '';
    activeInput: boolean = true;
    //confirmation dialog
    showConfirmationDialog: boolean = false;
    confirmationDialogTitle: string = 'Guardar Destinatario';
    defaultConfirmationMessage: string = '¿Está seguro que desea aplicar y guardar los cambios realizados?';
    confirmationDialogMessage: string = this.defaultConfirmationMessage;

    //cancel dialog
    showCancelDialog: boolean = false;
    cancelDialogTitle: string = 'Cancelar';
    cancelDialogMessage: string = '¿Está seguro que desea cancelar y salir?';

    isFormValid() {
        return this.nameInput.length > 0 && this.selectedCompanies.length > 0;
    }

    handleSelected(itemToAdd) {
        this.selectedCompanies.push(itemToAdd);
    }

    handleRemoveOption(itemToRemove) {
        this.selectedCompanies = this.selectedCompanies.filter(item => item['id'] !== itemToRemove['id']);
    }

    openCancelDialog() {
        if (
            this.numberInput.length > 0 ||
            this.nameInput.length > 0 ||
            this.mailInput.length > 0 ||
            this.selectedCompanies.length > 0
        ) {
            this.showCancelDialog = true;
        }
    }

    closeCancelDialog(confirm: boolean) {
        this.showCancelDialog = false;
        if (confirm) {
            this.closeDialog(false, null);
            this.cleanInputs();
        }
    }

    get getConfirmationDialogMessage() {
        if (this.recipientToEdit && this.recipientToEdit.report_subscription) {
            return (
                'Este destinatario está asociado a ' +
                this.recipientToEdit.report_subscription +
                ' reportes.<br> Si la cuenta de correo no es de Google perderá acceso a estos reportes y tendrá que suscribirse nuevamente a ellos.<br> <b>¿Está seguro que desea continuar?</b>'
            );
        }
        return this.defaultConfirmationMessage;
    }

    openConfirmationDialog() {
        this.showConfirmationDialog = true;
    }

    closeConfirmationDialog(confirm: boolean) {
        this.showConfirmationDialog = false;
        if (confirm) {
            this.cancelToken = Axios.CancelToken.source();
            let recipientToAdd = {
                name: this.nameInput,
                phone_number: this.numberInput != '' ? this.numberInput : null,
                mail: this.mailInput !== '' ? this.mailInput : null,
                active: this.activeInput,
                companies: this.getIDFromObject(this.removeDuplicatedFromObject(this.selectedCompanies))
            };

            if (this.$_getSelectedCompanyById != null) {
                if (this.editing) {
                    let recipientId = this.recipientToEdit.id;
                    this.pendingRequest = true;
                    SettingsService.patchRecipientByID(recipientToAdd, recipientId)
                        .then(res => {
                            this.$_successPatchRecipients('Destinatario modificado con éxito.');
                            this.pendingRequest = false;
                            recipientToAdd = res['data'];
                            this.updateRecipientInSelectedOnes(recipientToAdd);
                            this.closeDialog(true, recipientToAdd);
                            this.cleanInputs();
                        })
                        .catch(err => {
                            if (err && err.response && err.response.data && err.response.data.message) {
                                this.$_errorPatchRecipients(err.response.data.message);
                            } else {
                                this.$_errorPatchRecipients('Error al intentar modificar destinatario.');
                            }

                            this.pendingRequest = false;
                        });
                } else {
                    this.pendingRequest = true;
                    SettingsService.postRecipient(recipientToAdd, this.$_getSelectedCompanyById)
                        .then(data => {
                            this.addNewRecipient(data);
                            this.$_successAddRecipients('Destinatario creado con éxito.');
                            this.pendingRequest = false;
                            this.closeDialog(true, data);
                            this.cleanInputs();
                        })
                        .catch(err => {
                            this.$_errorAddRecipients('Error al intentar crear destinatario.');
                            this.pendingRequest = false;
                        });
                }
            }
        }
    }

    removeDuplicatedFromObject(object) {
        let uniqueObject = object.filter(function(item, pos) {
            return object.indexOf(item) == pos;
        });

        return uniqueObject;
    }

    getIDFromObject(object) {
        let ids: any = [];
        for (let i = 0; i < object.length; i++) {
            ids.push(object[i].id);
        }
        return ids.join(',');
    }

    cleanInputs() {
        this.nameInput = '';
        this.numberInput = '';
        this.mailInput = '';
        this.activeInput = true;
        this.preselectedCompanies = [];
        this.selectedCompanies = [];
    }

    inputRules: any = {
        number: [val => (val || '').length > 0 || 'Debe ingresar un teléfono'],
        name: [val => (val || '').length > 0 || 'Debe ingresar un nombre'],
        mail: [val => (val && val.length > 0 && !val.includes('@') ? 'Debe ingresar un correo electrónico' : true)]
    };

    @Emit()
    closeDialog(action: boolean, recipient: any) {}

    @Emit()
    updateRecipientInSelectedOnes(recipient) {}

    @Emit()
    addNewRecipient(recipient) {}

    @Watch('editing', { deep: true, immediate: true })
    switchToEdit(value) {
        if (value) {
            this.numberInput = this.recipientToEdit.phone_number;
            this.mailInput = this.recipientToEdit.mail;
            this.nameInput = this.recipientToEdit.name;
            this.activeInput = this.recipientToEdit.active;
            this.preselectedCompanies = this.recipientToEdit['companies'];
            this.selectedCompanies = this.recipientToEdit['companies'];
        } else {
            this.preselectedCompanies = [];
            this.selectedCompanies = [];
        }
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    mounted() {
        this.handleListenKey(true);
    }
}
